import { axiosV2 } from "config/@axios";
import i18next from "i18next";
import * as uiActions from "store/actions/uiActions";

export const REPLY_CALENDAR_INVITATION =
  "calendarActions::replyCalendarInviation";
export const REPLY_CALENDAR_INVITATION_LOADING =
  "calendarActions::replyCalendarInviationLoading";
export const REPLY_CALENDAR_INVITATION_SUCCESS =
  "calendarActions::replyCalendarInviationSuccess";
export const REPLY_CALENDAR_INVITATION_FAILURE =
  "calendarActions::replyCalendarInviationFailure";

export const replyCalendarInviation = (obj, onCompleted) => dispatch => {
  dispatch({
    type: REPLY_CALENDAR_INVITATION_LOADING
  });
  dispatch(uiActions.setLoading(true));

  return axiosV2
    .post("/calendars/_reply", obj)
    .then(res => {
      onCompleted();
      dispatch({
        type: REPLY_CALENDAR_INVITATION_SUCCESS
      });
    })
    .catch(err => {
      dispatch({
        type: REPLY_CALENDAR_INVITATION_FAILURE
      });
      dispatch(
        uiActions.addSnackbar({
          message: i18next.t("generic:errors.unexpected")
        })
      );
    })
    .finally(() => {
      dispatch(uiActions.setLoading(false));
    });
};
